const WishlistApp = {
  apiUrl: 'https://shopify-wishlist-app-production.up.railway.app',
  customerId: null,
  wishlist: [],

  init() {
    // Récupère le customer ID si connecté
    const meta = document.querySelector('meta[name="customer-id"]');
    this.customerId = meta ? meta.getAttribute('content') : null;

    // Charge la wishlist
    if (this.customerId) {
      this.loadFromServer();
    } else {
      this.loadFromLocal();
    }

    // Init tous les boutons
    this.initButtons();
  },

  loadFromLocal() {
    const stored = localStorage.getItem('wishlist');
    this.wishlist = stored ? JSON.parse(stored) : [];
    this.updateButtons();
  },

  async loadFromServer() {
    try {
      const res = await fetch(`${this.apiUrl}/apps/wishlist/${this.customerId}`);
      const data = await res.json();
      this.wishlist = data.wishlist || [];
      // Sync localStorage → server si guest avait des items
      const local = localStorage.getItem('wishlist');
      if (local) {
        const localItems = JSON.parse(local);
        for (const handle of localItems) {
          if (!this.wishlist.includes(handle)) {
            await this.toggle(handle, true);
          }
        }
        localStorage.removeItem('wishlist');
      }
      this.updateButtons();
    } catch (err) {
      console.error('Wishlist load error:', err);
      this.loadFromLocal();
    }
  },

  initButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const handle = btn.getAttribute('data-product-handle');
        await this.toggle(handle);
      });
    });
  },

  async toggle(handle, silent = false) {
  // 1. Update UI immédiatement (optimistic)
  const index = this.wishlist.indexOf(handle);
  if (index === -1) {
    this.wishlist.push(handle);
  } else {
    this.wishlist.splice(index, 1);
  }
  if (!silent) this.updateButtons();

  // 2. Sync en arrière-plan
  if (this.customerId) {
    try {
      const res = await fetch(`${this.apiUrl}/apps/wishlist/toggle`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: this.customerId, productHandle: handle })
      });
      const data = await res.json();
      this.wishlist = data.wishlist;
      if (!silent) this.updateButtons();
    } catch (err) {
      console.error('Toggle error:', err);
    }
  } else {
    localStorage.setItem('wishlist', JSON.stringify(this.wishlist));
    fetch(`${this.apiUrl}/apps/wishlist/toggle-count`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productHandle: handle, wishlist: this.wishlist })
    }).catch(err => console.error(err));
  }
},

  updateButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      const isWishlisted = this.wishlist.includes(handle);
      const iconEl = btn.querySelector('.wishlist-icon');
      const textEl = btn.querySelector('.wishlist-text');
      const wrapper = btn.closest('.groupwishreturn');
const linkEl = wrapper ? wrapper.querySelector('.wishlist-link') : null;

      btn.classList.toggle('is-wishlisted', isWishlisted);

      if (iconEl) iconEl.innerHTML = isWishlisted ? '♥' : '♡';
      if (textEl) {
        // Détecte la langue du site
        const lang = document.documentElement.lang || 'en';
        if (lang.startsWith('ja')) {
          textEl.textContent = isWishlisted ? '追加済み！' : 'お気に入り';
        } else {
          textEl.textContent = isWishlisted ? 'Saved' : 'Wishlist';
        }
      }
      if (linkEl) {
          linkEl.style.display = isWishlisted ? 'block' : 'none';
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', () => WishlistApp.init());